import React, { useEffect, useLayoutEffect, useState } from 'react';

import { Web } from '@mui/icons-material';
import { Container, Row } from 'react-bootstrap';
import { useSelector } from 'react-redux';
import { useLocation, useNavigate } from 'react-router-dom';

import { DriverSolutionsMenuItem, SubHeader } from '../../../components';

import './styles.scoped.css';

const DriverSolutions = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { clientMenu, entryTypeMenu, managementMenu } = useSelector(state => state.expenseEntry);
  const appAccess = useSelector(state => state.admin?.user?.appAccess);
  const [currentExpenseRole, setCurrentExpenseRole] = useState('');
  const [assignmentLineOfBusinessItems, setAssignmentLineOfBusinessItems] = useState({});

  const getAssignmentLineOfBusinessItems = () => {
    clientMenu?.menuItems?.forEach(i => {
      if (location.pathname.includes(i.to)) {
        setAssignmentLineOfBusinessItems(i);
      }
    });
  };

  useLayoutEffect(() => {
    if (location.pathname.includes('driver-management-services')) {
      document.querySelector('div.root').style.background = '#D0CED0';
      document.querySelector('span.wrap').style.background = '#ffff';
    }
    return () => {
      document.querySelector('div.root').style.background = '#ffff';
    };
  }, [location.pathname]);

  useEffect(() => {
    getAssignmentLineOfBusinessItems();
  }, []);

  useEffect(() => {
    const access = appAccess?.items?.filter(app => app.appId?.name === 'Expense Entry')?.[0];
    if (access && access.roleId) {
      setCurrentExpenseRole(access?.roleId?.id);
    }
  }, [appAccess, location.pathname]);

  const onPress = item => {
    navigate(item.to);
  };

  return (
    <>
      <SubHeader
        text="Expenses"
        buttons={[{ icon: <Web sx={{ color: '#fff', fontSize: 30 }} />, onPress: () => navigate('/dashboard') }]}
        popoverTitle="Need help with your Expenses?"
      />

      <h1 className="header">{assignmentLineOfBusinessItems.text}</h1>

      {currentExpenseRole ? (
        <>
          <h1 key={`${entryTypeMenu.header}-h1`} className="sub-header ">
            {entryTypeMenu[0].header}
          </h1>
          <Container className="wrap">
            {entryTypeMenu.map(item => (
              <div key={item.header}>
                <Row className="row" key={`${item.header}-row`}>
                  {item.items.map(
                    i =>
                      i.to.includes(assignmentLineOfBusinessItems.to) && (
                        <DriverSolutionsMenuItem key={i.icon} text={i.text} icon={i.icon} onPress={() => onPress(i)} />
                      ),
                  )}
                </Row>
              </div>
            ))}
          </Container>
        </>
      ) : null}

      {currentExpenseRole === '9' || currentExpenseRole === '31' || currentExpenseRole === '32' || currentExpenseRole === '33' ? (
        <>
          <h1 key={`${managementMenu.header}-h1`} className="sub-header">
            {managementMenu[0].header}
          </h1>
          <Container className="wrap">
            {managementMenu.map(item => (
              <div key={item.header}>
                <Row className="row" key={`${item.header}-row`}>
                  {item.items.map(
                    i =>
                      i.to.includes(location.pathname) && (
                        <DriverSolutionsMenuItem
                          key={i.icon}
                          text={i.text}
                          icon={i.icon}
                          onPress={() => onPress(i)}
                          disabled={i.disabled}
                        />
                      ),
                  )}
                </Row>
              </div>
            ))}
          </Container>
        </>
      ) : null}
    </>
  );
};

export default DriverSolutions;
